// ============================================================
// همگام نگه داشتن اندازه‌ی نقشه با ظرفش
//
// دو مشکل را با هم حل می‌کند:
//
// ۱) کرش «Cannot read properties of undefined (reading 'classList')»
//    لیف‌لت با هر resize پنجره یک requestAnimationFrame زمان‌بندی
//    می‌کند که invalidateSize صدا می‌زند، ولی map.remove() آن فریم را
//    لغو نمی‌کند و در عوض _mapPane را پاک می‌کند. اگر نقشه بین این دو
//    unmount شود — مودال بسته شود، مسیر عوض شود — فریم روی نقشه‌ی
//    مرده می‌نشیند و panBy روی pane ناموجود addClass می‌زند.
//
//    در این سامانه زیاد پیش می‌آید، چون Layout با هر تغییر چیدمان
//    خودش window.dispatchEvent(new Event("resize")) می‌زند.
//
//    پس trackResize لیف‌لت خاموش می‌شود (روی MapContainer) و ردگیری
//    به ResizeObserver سپرده می‌شود که با unmount قطع می‌شود.
//
// ۲) نقشه‌ی داخل مودال که در لحظه‌ی mount ابعادش صفر دیده می‌شود.
//    ResizeObserver همان اول یک بار صدا می‌زند و همین کافی است؛
//    نیازی به setTimeout حدسی نیست.
//
// نکته‌ی نگه‌داری: animate: false عمدی است. با animate: true مسیر
// panBy و همان addClass روی pane باز می‌شود — یعنی دقیقاً چیزی که
// می‌خواستیم از آن دور بمانیم.
// ============================================================

import { useEffect } from "react";
import { useMap } from "react-leaflet";

const MapAutoSize: React.FC = () => {
    const map = useMap();

    useEffect(() => {
        const container = map.getContainer();

        const refresh = () => {
            // اگر ظرف از DOM جدا شده باشد، نقشه دیگر pane ندارد.
            if (!container.isConnected) return;
            map.invalidateSize({ animate: false, pan: true, debounceMoveend: true });
        };

        const observer = new ResizeObserver(refresh);
        observer.observe(container);

        return () => observer.disconnect();
    }, [map]);

    return null;
};

export default MapAutoSize;
